/**
 * Created by ivo on 22.05.14.
 *
 * Accordion component for destination pages
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'clientComponents/accordion/contentNode',
    'library/fcse-dropdown/dropdown'
    ],
    function($, Object, OptionsMixin, EventDispatcher, ContentNode, Dropdown) {
        /**
         * Abstract pseudo class for the creational process of
         * the filter widgets.
         *
         * @constructor
         * @param {Object} scope
         * @param array An array of widgets to be instantiated
         * @returns {_L1.WidgetFactory}
         */
        var Node = function(element, requestHandler, scope, options) {
            EventDispatcher.apply(this, arguments);

            // Store element
            this.element = element;

            // Set default options
            var defaultOptions = {
                openClass: 'is-active',
                closedClass: 'is-closed'
            };
            this.addOptions(defaultOptions, options);

            // Save local variables
            this.requestHandler = requestHandler;
            this.scope = scope;
            this.contentIsLoaded = false;

            this._init();

            // Init event handling
            this._initEventHandling();

            // Init content nodes
            this._initContentNodes();
        };

        Node.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin), {
            /**
             * Initializer
             * @private
             */
            _init: function() {
                $(this.element).data('node-instance', this);
            },
            /**
             * Initializes event handlers
             * @private
             */
            _initEventHandling: function(){
                var self = this;
                $('[data-fcse-role="accordion--node--header"]', this.element).click(function(){
                    self.toggle();
                });
            },

            /**
             * Initializes the content nodes
             * @private
             */
            _initContentNodes: function(){
                var self = this;
                $('[data-fcse-role="accordion--contentnode"]', this.element).each(function(index, element){
                    var contentNode = new ContentNode(element, self.requestHandler, self.scope, {
                        nodeContentRoute: self.option('nodeContentRoute')
                    });
                });
            },

            /**
             * Returns true if the node is open
             * @return boolean
             */
            isOpen: function(){
                return $(this.element).hasClass(this.option('openClass'));
            },

            /**
             * Opens the accordion node
             */
            open: function(){
                $(this.element)
                    .addClass(this.option('openClass'))
                    .removeClass(this.option('closedClass'));
            },

            /**
             * Closes the accordion node
             */
            close: function(){
                $(this.element)
                    .removeClass(this.option('openClass'))
                    .addClass(this.option('closedClass'));
            },

            /**
             * Toggles the open state of the accordion node
             */
            toggle: function(){
                if (this.isOpen()){
                    this.close();
                } else {
                    this.open();
                }
            }
        });

        return Node;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/accordion/node.js